module.exports = window.fetch || (window.fetch = require('unfetch').default || require('unfetch'));



//////////////////
// WEBPACK FOOTER
// ../node_modules/isomorphic-unfetch/browser.js
// module id = 704
// module chunks = 68